<template>
  
    <video width="100%" height="100%" preload="auto" autoplay loop controls >
        <source :src="'/'+video" type="video/mp4">
      </video>
  
</template>
<style lang="scss">
</style>
<script>
export default {
  props: ["video"],
  data: () => ({})
};
</script>
